import * as React from "react";
import { UserResource } from "client/resources";
import { Link } from "react-router-dom";
import * as cn from "classnames";
import Popover from "material-ui/Popover";
import Menu from "material-ui/Menu";
import { Avatar } from "components/Avatar/Avatar";
import ExternalLink from "../Navigation/ExternalLink";
import { GettingStartedDialog } from "components/GettingStarted/GettingStartedDialog";
import MenuItem from "material-ui/MenuItem";
import { repository } from "clientInstance";
import {primaryText, primary, secondaryText, divider} from "colors";

import styles = require("./style.less");
import Divider from "../Divider/Divider";
import InternalLink from "../Navigation/InternalLink/InternalLink";
import routeLinks from "../../routeLinks";

interface UserAccountMenuState {
    isMenuOpen: boolean;
    showGettingStarted: boolean;
    version: string;
}

interface UserAccountMenuProps {
    currentUser: UserResource;
}

export default class UserAccountMenu extends React.Component<UserAccountMenuProps, UserAccountMenuState> {
    private menuButton: HTMLElement;

    constructor(props: UserAccountMenuProps) {
        super(props);

        this.state = {
            isMenuOpen: false,
            showGettingStarted: false,
            version: ""
        };
    }

    componentDidMount() {
        const version = repository.getRootDocument().Version;
        this.setState({ version });
    }

    render() {
        return <div>
            {this.state.showGettingStarted && <GettingStartedDialog onNavigating={this.closeGettingStarted}
                open={this.state.showGettingStarted} onClose={this.closeGettingStarted} />}
            <a className={cn(styles.button)}
                onClick={this.handleTouchTap}
                href="#"
                ref={this.setRef}>
                <Avatar user={this.props.currentUser} size={24} />
                <span className={cn(styles.userName, "hide-sm")}>
                    {this.props.currentUser.DisplayName}
                </span>
                <em className={cn("fa fa-caret-down", styles.icon)} />
            </a>

            <Popover
                open={this.state.isMenuOpen}
                anchorEl={this.menuButton}
                onRequestClose={this.handleRequestClose}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                targetOrigin={{ horizontal: "right", vertical: "top" }}>
                <Menu>
                    <MenuItem style={{ color: secondaryText, fontSize: "0.875rem"}} disabled={true}>{`Octopus v${this.state.version}`}</MenuItem>
                    <Divider />
                    <InternalLink to={routeLinks.currentUser.signOut} onClick={this.handleRequestClose}><MenuItem primaryText="Sign Out" /></InternalLink>
                    <InternalLink to={routeLinks.currentUser.me} onClick={this.handleRequestClose}><MenuItem primaryText="Profile" /></InternalLink>
                    <MenuItem primaryText="Show Getting Started" onClick={this.showGettingStarted} />
                    <Divider />
                    <ExternalLink href="DocumentationHome" showIcon={false}>
                        <MenuItem style={{ color: primary }} onClick={this.handleRequestClose} primaryText="Documentation" />
                    </ExternalLink>
                    <ExternalLink href={window.location.origin + window.location.pathname + "/../swaggerui/"} showIcon={false}>
                        <MenuItem style={{ color: primary }} onClick={this.handleRequestClose} primaryText="API Documentation" />
                    </ExternalLink>
                    <ExternalLink href="HelpGeneral" showIcon={false}>
                        <MenuItem style={{ color: primary }} onClick={this.handleRequestClose} primaryText="Support" />
                    </ExternalLink>
                    <ExternalLink href="TrainingVideos" showIcon={false}>
                        <MenuItem style={{ color: primary }} onClick={this.handleRequestClose} primaryText="Training Videos" />
                    </ExternalLink>
                    <ExternalLink href="HelpMakeSuggestion" showIcon={false}>
                        <MenuItem style={{ color: primary }} onClick={this.handleRequestClose} primaryText="Suggestions" />
                    </ExternalLink>
                    <ExternalLink href="https://octopus.com/downloads" showIcon={false}>
                        <MenuItem style={{ color: primary }} onClick={this.handleRequestClose} primaryText="Downloads" />
                    </ExternalLink>
                </Menu>
            </Popover>
        </div>;
    }

    private setRef = (el: HTMLElement) => {
        this.menuButton = el;
    }

    private closeGettingStarted = () => {
        this.setState({ showGettingStarted: false });
    }

    private handleTouchTap = (event: any) => {
        event.preventDefault();

        this.setState({
            isMenuOpen: !this.state.isMenuOpen
        });
    }

    private handleRequestClose = () => {
        this.setState({
            isMenuOpen: false,
        });
    }

    private showGettingStarted = () => {
        this.setState({
            isMenuOpen: false,
            showGettingStarted: true
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Navbar/UserAccountMenu.tsx